import React from 'react';
import { RandomEvent } from '../../types';
import { playUiSfx } from '../../utils/uiAudio';
import { ModalShell, buttons, cn } from './kit';

interface EventModalProps {
    event: RandomEvent;
    onAcknowledge: () => void;
}

const EventModal: React.FC<EventModalProps> = ({ event, onAcknowledge }) => {
    const isPositive = event.type === 'positive';
    const colorClass = isPositive ? 'text-emerald-400 border-emerald-500' : 'text-red-500 border-red-500';
    const bgClass = isPositive ? 'bg-emerald-950/90' : 'bg-red-950/90';

    return (
        <ModalShell
            variant="center"
            zLevel="modalHigh"
            overlayClassName="bg-black/60 backdrop-blur-sm"
            className="max-w-md"
        >
            <div className={cn(bgClass, 'border-2', colorClass, 'rounded-xl p-8 shadow-[0_0_50px_rgba(0,0,0,0.5)] relative overflow-hidden')}>
                <div className="absolute inset-0 pointer-events-none opacity-10 bg-[linear-gradient(45deg,transparent_25%,rgba(255,255,255,0.2)_50%,transparent_75%)] bg-[length:20px_20px]" />

                <div className="relative z-10 text-center">
                    <div className="text-6xl mb-4">{isPositive ? '📈' : '⚠️'}</div>
                    <h2 className={cn('text-3xl font-black uppercase tracking-tighter mb-2', isPositive ? 'text-emerald-300' : 'text-red-400')}>
                        {event.name}
                    </h2>
                    <div className="w-full h-px bg-white/20 mb-6" />
                    <p className="text-white text-lg font-medium leading-relaxed mb-8">
                        {event.description}
                    </p>

                    <button
                        type="button"
                        onClick={() => { playUiSfx(isPositive ? 'success' : 'click'); onAcknowledge(); }}
                        className={cn(buttons.primary, 'w-full py-4 text-sm hover:scale-[1.02] transition-transform shadow-lg')}
                    >
                        {isPositive ? 'Claim Benefit' : 'Acknowledge Alert'}
                    </button>
                </div>
            </div>
        </ModalShell>
    );
};

export default EventModal;